var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('details',{staticClass:"details-summary",class:{'active': _vm.active}},[_c('summary',{staticClass:"details-summary__header text-sub-heading",class:_vm.headerClasses,on:{"click":_vm.toggleActive}},[_vm._t("header")],2),_c('div',{staticClass:"details-summary__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }